export default {
    429401: 429004001,
    429402:	429004002,
    429403:	429004003,
    429404:	429004100,
    429405:	429004101,
    429406:	429004102,
    429407:	429004103,
    429408:	429004104,
    429409:	429004105,
    429410:	429004106,
    429411:	429004107,
    429412:	429004108,
    429413:	429004109,
    429414:	429004110,
    429415:	429004111,
    429416:	429004112,
    429417:	429004113,
    429418:	429004114,
    429419:	429004400,
    429420:	429004401,
    429421:	429004402,
    429422:	429004404,
    429423:	429004405,
    429424:	429004407,
    429425:	429004408,
    429501:	429005001,
    429502:	429005002,
    429503:	429005003,
    429504:	429005004,
    429505:	429005005,
    429506:	429005006,
    429507:	429005100,
    429508:	429005101,
    429509:	429005102,
    429510:	429005103,
    429511:	429005104,
    429512:	429005105,
    429513:	429005106,
    429514:	429005107,
    429515:	429005108,
    429516:	429005109,
    429517:	429005400,
    429518:	429005401,
    429519:	429005450,
    429520:	429005451,
    429521:	429005452,
    429522:	429005453,
    429523:	429005454,
    429524:	429005455,
    429525:	429005457,
    429601: 429006001,
    429602:	429006002,
    429603:	429006003,
    429604:	429006100,
    429605:	429006101,
    429606:	429006102,
    429607:	429006103,
    429608:	429006104,
    429609:	429006105,
    429610:	429006106,
    429611:	429006107,
    429612:	429006108,
    429613:	429006109,
    429614:	429006110,
    429615:	429006111,
    429616:	429006112,
    429617:	429006113,
    429618:	429006114,
    429619:	429006115,
    429620:	429006116,
    429621:	429006118,
    429622:	429006119,
    429623:	429006120,
    429624:	429006121,
    429625:	429006201,
    429626:	429006450,
    429627:	429006451,
    429628:	429006452,
    429701:	429021100,
    429702:	429021101,
    429703:	429021102,
    429704:	429021103,
    429705:	429021104,
    429706:	429021105,
    429707:	429021200,
    429708:	429021202,
}
